import { render, staticRenderFns } from "./QuizInfo.vue?vue&type=template&id=74153fab&scoped=true&"
import script from "./QuizInfo.vue?vue&type=script&lang=js&"
export * from "./QuizInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuizInfo.vue?vue&type=style&index=0&id=74153fab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74153fab",
  null
  
)

export default component.exports